import React, { useState } from 'react'
import LocalizedText from '../presentational/LocalizedText';
import useTranslate from "../../hooks/useTranslate";
import { Button, FormGroup, Input, InputGroup, Intent } from '@careevolution/design-system';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-regular-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface ResetPasswordProps {
  serverError: string;
  isLoading: boolean;
  emailOrPhone: string;
  finishPasswordReset: (password: string) => void
  isValidPassword: (password: string) => boolean
  setEmailOrPhone: (emailOrPhone: string) => void
}

const ResetPassword: React.FC<ResetPasswordProps> = ({
  serverError,
  isLoading,
  emailOrPhone,
  finishPasswordReset,
  isValidPassword,
}) => {
  const [unmaskPassword, setUnmaskPassword] = useState(false)
  const [password, setPassword] = useState('')
  const translations = useTranslate(["participant-login-password-label", "participant-login-password-placeholder", "participant-login-next-label"])

  const onSetPassword = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(event?.target?.value)
  }

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    finishPasswordReset(password)
    return false
  }

  return (
    <form className="login-action" onSubmit={handleSubmit}>
      <h1>
        <LocalizedText textKey="participant-login-reset-password-title" />
      </h1>
      <p>
        <LocalizedText textKey="participant-login-reset-password-info" values={{ emailOrPhone: emailOrPhone }} />
      </p>
      {
        serverError && (
          <p className="server-error">{serverError}</p>
        )
      }
      <FormGroup className="login-field" label={translations["participant-login-password-label"]}>
        <InputGroup>
          <Input
            onChange={onSetPassword}
            autoComplete="new-password"
            className="autofocus"
            disabled={isLoading}
            id="resetPassword"
            type={unmaskPassword ? 'text' : 'password'}
            value={password}
            placeholder={translations["participant-login-password-placeholder"]}
            fullWidth={true}
            htmlAttributes={{
              onInput: onSetPassword,
              spellCheck: false,
              autoCorrect: "off",
              autoCapitalize: "none",
              maxLength: 64,
            }}
          />
          <button
            type="button"
            onClick={() => setUnmaskPassword(!unmaskPassword)}
            className="password-mask-toggle"
            title="Toggle password visibility">
               <FontAwesomeIcon icon={unmaskPassword ? faEye as IconProp: faEyeSlash as IconProp} />
          </button>
        </InputGroup>
      </FormGroup>
      <Button
        onClick={handleSubmit}
        disabled={!isValidPassword(password)}
        className="primary-action"
        width="100%"
        loading={isLoading}
        type='submit'
        intent={Intent.primary}
      >
        <span dangerouslySetInnerHTML={{ __html: translations["participant-login-next-label"] }} />
      </Button>
    </form>
  )
}

export default ResetPassword